import axiosInstance from "../Axios-Config/Axios-Config";
import { ErrorToast } from "../components/ToastComponent/ErrorToast";
export const RazorpayCreateOrder = async (state: any) => {
    try {
        const { data }: any = await axiosInstance.post("create-order", state);
        if (data?.success) {
            // SuccessToast(data.message);
            return data;
        } else {
            ErrorToast(data?.message);
            return false;
        }
    } catch (error: any) {
        ErrorToast(error.message);
        return false;
    }
};

export const RazorpayVerifyOrder = async (state: any) => {
    try {
        const { data }: any = await axiosInstance.post("verify-payment", state);
        if (data?.success) {
            // SuccessToast(data.message);
            return data;
        } else {
            ErrorToast(data?.message);
            return false;
        }
    } catch (error: any) {
        ErrorToast(error.message);
        return false;
    }
};


